import React, { useState, useEffect, useContext } from "react";
import * as appSetup from "../custom/appSetup";
import { LivestateContext } from "./LivestateContext";

let initialState = {
  config: {
    mode: "production",
    ui: {
      tooltipWidth: 300,
      sidebarWidth: 400,
    },
  },
  project: {
    dsc: "Uetliblick Gattikon",
    adress: "Ochsenrainstrasse 7a + 7b, 8136 Gattikon-Thalwil",
    backgroundImages: [
      "f1001",
      "f1002",
      "f1003",
      "f1004",
      "f1005",
      "f1006",
      "f1007",
      "f1008",
      "f1009",
    ],
    settings: {
      statustable: {
        free: {
          id: "0",
          dsc: "verfügbar",
          colorCode: "g",
          contact: "1",
          price: "1",
          tour: "1",
        },
        reserved: {
          id: "1",
          dsc: "reserviert",
          colorCode: "y",
          contact: "0",
          price: "0",
          tour: "0",
        },
        rented: {
          id: "2",
          dsc: "vermietet",
          colorCode: "r",
          contact: "0",
          price: "0",
          tour: "1",
        },
        sold: {
          id: "3",
          dsc: "verkauft",
          colorCode: "r",
          contact: "0",
          price: "0",
          tour: "1",
        },
        unknow: {
          id: "4",
          dsc: "unbekannt",
          colorCode: "r",
          contact: "0",
          price: "0",
          tour: "0",
        },
      },
    },
    location: {
      url: "https://www.google.com/maps/place/Ochsenrainstrasse+7%2F7b,+8136+Gattikon/data=!4m2!3m1!1s0x479aa7d881e13251:0x840eb6ae9d9fe6a2?sa=X&ved=2ahUKEwi9isSlk9n9AhUShv0HHdA0BBYQ8gF6BAgJEAI",
      street: "Ochsenrainstrasse 7a + 7b",
      city: "8136 Gattikon-Thalwil",
    },
  },
  plans: {
    factsheet: {
      9901: "data/plans/factsheet/9901.pdf",
      1: "data/plans/factsheet/1.pdf",
      2: "data/plans/factsheet/2.pdf",
      101: "data/plans/factsheet/101.pdf",
      102: "data/plans/factsheet/102.pdf",
      201: "data/plans/factsheet/201.pdf",
      202: "data/plans/factsheet/202.pdf",
    },
    situation_plan: "",
    basement1_plan:
      "data/plans/additional_plans/uetliblick_gattikon_basement1_plan.pdf",
    basement2_plan:
      "data/plans/additional_plans/uetliblick_gattikon_basement2_plan.pdf",
    basement3_plan: "",
    environment_plan:
      "data/plans/additional_plans/uetliblick_gattikon_environment_plan.pdf",
  },
  tours: {
    101: "https://biganto.com/tour/37531/",
  },

  units: {
    1: {
      adress: "",
      area: "90.44",
      custom_1: "",
      custom_2: "",
      custom_3: "97.5",
      custom_4: "8",
      custom_5: "",
      custom_6: "",
      document: "",
      dsc: "WHG 1",
      floor: "3",
      id: "1",
      name: "WHG 1",
      player: "",
      price: "1'980'000",
      price_per_sm: "",
      rooms: "4.5",
      se_id: "0301",
      status: "5",
      tour: "",
      tour_2: "",
      type: "Wohnung",
      url_1: "",
      url_2: "",
      url_3: "",
    },
  },
  svg: {
    f1001: {
      6: "m1346.68,631.22l-19.53-39.52-3.07-99.47-10.13-19.37-304.36,9.58-1.17,10.25-100.66,2.88-16.71,50.54,4.66-.05,8.98,110.24,327.23-13.81,114.99-4.85-.24-6.42Z",
      5: "m1002.68,445.01l-3.5-.02,3.67-24.12,327.33-9.09,10.21,11.19,2.5,69.79,19.22,34.28.19,5.56-36.62,1.32-.22-5.57-.99-25.91-.35-9.06-.03-1.15-10.13-19.37-44.95,1.44-259.41,8.14-1.17,10.25-6.91.37-2.18-27.21-3.33.12,1.16-11.72,5.9.25-.4-9.5Z",
      4: "m1461.99,726.09l-111.84,5.41-436.69,21.12-8.76-96.31,442.22-18.66.31,12.21,73.38-3.14,41.25,73.14.13,6.23Z",
      3: "m1460.61,617.04l-37.51-53.74-60.35,2.24-.47-32.93-36.62,1.32,1.48,57.78,17.74,35.54,20.01-.83,95.82-3.98-.11-5.41Z",
      2: "m1350.15,731.5l73.46-3.55,40.08,79.68.13,6.08-110.5,6.01-431.31,23.46-8.55-90.56,436.69-21.12",
      1: "m1498.72,700.52l-46.53,2.18-2.93-5.18-14.51-25.74-14.14-25.07-48.5,2.08-6.59.28-18.31.78-.54-18.63-1.8-3.97,20.01-.83.19,5.54,92.86-3.89,40.69,67.16.08,5.29Z",
      0: "M1498.9,700.5h-0.1v-0.2l-0.1-5.1l-6.8-10.7l-3.2-4.9l18.9-0.9l89.3,154.1l-43.4,8l-35.9-66.9l-68.8,3.8l-25.1-49.8l38.4-1.9l-0.1-6.2l-9.7-17.2L1498.9,700.5",
    },
    f1002: {
      6: "m1270.94,530.93l-35.53,19.2-70.05,37.85-83.74-6.82-220.63-17.3-7.47-84.59,117.82-36.29,65.5,6.9,23.14-7.57,209.17,12.14,1.79,76.47Z",
      5: "m1419.41,405.57l-.05,67.14-23.84,13.8-50.21,29.05-67.12-4.43-7.79-.52-1.24-56.14-179.74-10.29-.5-16.58,24.37-8.03,23.47,1.25.05-8.83,53.73-17.37,228.87,10.96Z",
      4: "m1348.41,608.44l-94.38,67.44-85.2-8.06-300.57-27.74-7.27-76.21,304.37,24.11,105.58-57.05,1.62,66.9,75.79,6.09.05,4.52Z",
      3: "m1485.46,535.73l-.05,3.9-65.61,50.64-73.68-5.67-74.06-5.7-1.66-68.28,74.91,4.95,74.06-42.85-.05,58.61,66.15,4.41Z",
      2: "m1348.21,672.02l-91.95,75.67-84.06-9.03-296.85-31.17-7.08-67.41,300.57,27.74,84.34,7.98.85.08,20.06-14.34,1.01-.72,73.06,6.77.05,4.42Z",
      1: "m1510.57,589.19h-.09s-63.03,58.3-63.03,58.3l-103.47-8.58-33.98-3.01,36.44-26.04,1.97-1.41-.05-4.52-2-.16-73.8-5.93-.51-18.94,74.06,5.7,67.78,5.22,5.9.46,1.13-.87,7.94-6.14,81.7,5.93Z",
      0: "M1571.6,631.3l-0.1,6.7l-111.2,136.8l-70.9-7.5l51.5-53.7l-106.4-10.3l-0.3-19.7l14.1-11.5l-0.1-4.4l-14.3-1.3l-0.2-14l-34.1-3.1l-0.1-5.8l10.5-7.5l137.6,11.6l63-58.3l-0.7,37.1v0L1571.6,631.3L1571.6,631.3z",
    },
    f1003: {
      6: "m1210.04,542.2l-68.92,15.83-132.15,30.36-52.35-16.58-126.38-40.02-5.87-76.31,162.48-24.92,41.32,8.97,34.48-4.64,146.53,29.4.85,77.9Z",
      5: "m1197.08,420.22l-.13-9.02,85.95-13.73,186.37,29.58-2.34,69.36-51.89,12.38-107.08,25.55-51.81-11.92-46.49-10.7-.46-47.41-87.78-18.06-.74-23.02,39.48-6.15,26.5,4.87,10.42-1.72Z",
      4: "m1267.77,628.76l-199.6,57.76-55.8-20.4-176.4-65.68-5.72-68.65,178.73,56.6,201.07-46.19.77,65.7,56.95,16.26v4.59Z",
      3: "m1523.03,568.65l-.21,4.1-156.23,46.35-59.09-15.76-97.08-25.9-.77-65.72,98.31,22.61,158.97-37.92-2.13,59.49,58.23,12.76Z",
      2: "m1267.83,688.7v4.46l-196.08,64.36-55.1-22.75-175.11-73.29-5.57-61.05,176.4,65.68,55.8,20.4,143.11-41.66.34,25.64,56.21,18.21Z",
      1: "m1543.75,630.74l-.09-.02-154.05,53.37h0l-156.89-45.35,35.05-9.99v-4.59s-56.96-16.26-56.96-16.26l-.39-30.47,97.08,25.9,59.09,15.76,96.83-28.73-.86,21.74,81.2,18.62Z",
      0: "M1542,661.8l1.7-31.1l-154.1,53.4l-119.4-34.5v62.7l14.4,4.9l94.1,31.8L1247,801l53.6,22.2l322.5-134.6l0.3-3.9L1542,661.8L1542,661.8z",
    },
    f1004: {
      6: "m1156.71,430.8l-3.04,77-81.87,4.05-148.74,8.77-20.16-17.84-46.42-40.46-.67-67.35,164.68-7.44,20.22,10.23,38.21-2.06,77.79,35.1Z",
      5: "m1479.05,420.75l-6.06,73.49-108.58,6.36-113.57,6.68-28.45-13.99-67.09-32.97h0l1.42-29.53-9.05-4.08.65-37.37,44.72-2.39,9.6,3.69,33.89.93.34-6.95,106.69-5.7,135.49,41.82Z",
      4: "m1183.09,588.21l-.18,5.97-234.51,21.6-21.85-22.38-68.44-71.04-1.63-60.04,66.58,57.8,230.7-12.8-1.94,61.05,31.27,19.85Z",
      3: "m1287.65,598.54l-36.14-21.9-98.13-56.76,1.91-59.56,95.52,46.94h0l222.17-13.04-5.49,59.29,43.66,18.98.03,5.34-223.52,20.71",
      2: "m1180.64,652.57l-.16,4.34-231.36,24.6-21.6-25.02-67.82-79.85-1.59-54.28,68.44,71.04,21.85,22.38,202.53-18.72-1.05,31.69,30.75,23.82Z",
      1: "m1522.86,638.15l-.48,4.28h0l-223.94,23.98-117.08-72.1,1.54-.14.18-5.97-31.27-19.85,1.56-48.48,98.13,56.76,36.14,21.9,177.12-16.41-3.06,29.97,61.15,26.05Z",
      0: "M1542.9,676.2l-24.2,2.8l3.7-36.5l-224,24l-72.2-43.5l-2.8,57.7l61.3,49L1108.3,750l26.5,26.9l478.7-59.4l0.6-4.2L1542.9,676.2L1542.9,676.2z",
    },
    f1005: {
      6: "m1143.27,473.03l-5.54,43.06-89.22-.7-153.23-1.22h0l10.98-15.7-3.27-75.06,30.7-37.29,170.58.19.16,11.48,38.45.05.38,75.19Z",
      5: "m1499.47,451.01l-4.5,76.19-91.97-.15-171.38-.27-1.61-14.4-4.66-41.73.61-73.35,50.93.06,2.03,7.31,51.94.06h-3.42s.23-7.31.23-7.31l127.4.15,44.42,53.44Z",
      4: "m1143.27,516.09l-5.05,69.3-2.21,22.8-251-.47-.25-4.6,11.77-22.54-1.24-66.4,242.43,1.93,5.55-42.78h0v42.77Z",
      3: "m1505.26,617.85l-.33,4.72-272.03-.52-2.08-23.98-6.08-70.45.6-56.97,6.27,56.13,263.36.42-4.08,66.82,14.37,23.84Z",
      2: "m1143.27,568.89l-4.55,78.65-2.19,25.28-247.52-.52-.28-4.47,12.94-25.06-2.05-35.03,236.38.44h0l7.27-92.1v52.81Z",
      1: "m1506.36,695.12h0l-273.89-1.75-2.4-31.77-5.91-78.33.58-55.65,6.08,70.45,2.08,23.98,256.08.49-2.35,35.18,19.74,37.4Z",
      0: "M1583.1,735.4l-79.7-0.9v0.2l3-39.6l-273.9-1.8l-3.6-48.2l-0.7,60.3l3.3,49.7l-210.4-0.2l-6.7,31.9l219.2,1.1l378.2,0.9l0.4-4.7L1583.1,735.4L1583.1,735.4z",
    },
    f1006: {
      6: "m1197.49,403.96l-1.84,64.21-83.26,30.36-70.38-8.47-116.27-16.13v-.19l33.41-7.57,1.72-64.97,86.01-20.66,139.7,12.85-.74,9.47,11.65,1.11Z",
      5: "m1500.26,430.83l-7.73,69.8-78.29,46.16-244.7-32.2h0l.02-.45,32.24-12.95,1.46-66.87,72.36-24.75,47.2,4.47-.66,6.28,36.23,3.5,12.99-5.19,128.88,12.2Z",
      4: "m1202.6,465.61h0l-.8,35.59-32.24,12.95-.65,20.46-62.69,26.49-32.26,13.81-186.01-29.53.11-3.88,37.17-11.42.52-56.14,185.67,24.11,84.25-29.87h0l6.94-2.56Z",
      3: "m1492.52,500.63l-8.51,62.09-79.53,54.26-26.09,17.8-243.96-39.11-.19-4.3,33.27-18.5,2.03-58.58h0l244.69,32.5,78.29-46.16Z",
      2: "m1134.25,591.37l.19,4.3,10.04,1.76-41.9,19.95-32.49,15.47-183.28-33.07.08-4.78,34.86-11.91.87-31.68,151.33,23.47h0l94.94-40.29-1.38,38.28-33.27,18.5Z",
      1: "m1484.01,562.72l-7.85,52.98-114.8,87.38h0l-244.89-44.07.02-.24,45.05-23.65,2.64-34.54,214.22,34.2,26.09-17.8,79.53-54.26Z",
      0: "M1380.2,752l71.5,14l-0.6,4.4l-35.6,34.5L918.3,697.5l48.3-19l146.5,29.5l3.3-49l244.9,44.1l114.8-87.4l-7.7,58.7l-91.4,77L1380.2,752",
    },
    f1007: {
      6: "m1257.55,384.91l-1.6,27.65-13.05,1.85-2.25.32-70.78,10.01-1.6,49.09-79.17,13.07h0l-132.56-33.72v-.55l52.93-5.05.53-65.75,136.11-15.48,111.45,18.56Z",
      5: "m1390.25,418.81l-28.19,4.35-13.47-2.41.68-9.04-39.25-6.8-140.15,19.82-2.15,70.34-53.23,9.54v.21l184.92,48.66h0l195.85-40.35,6.82-74.96-111.82-19.37Z",
      4: "m1168.26,473.82l-.55,21.25-53.23,9.75-1.08,40.72-25.84,4.77-56.97,10.51-128.8-39.59-.04-3.83,54.77-8.61.02-55.61,132.56,33.72,79.17-13.07Z",
      3: "m1495.25,513.14l-6.65,67.88-193.69,46.46-61.56,14.76h0s0,0,0,0h0s0,0,0,0l-180.27-57.54.09-4.39,59.5-11.58,1.81-63.89,184.92,48.66,195.85-40.35Z",
      2: "m1053.17,580.31l-.09,4.39,33.3,10.63,23.64,7.55-23.97,5.02-56.35,11.8-127.35-44.5-.04-3.75,54.18-9.71v-23.69s74.1,22.77,74.1,22.77l56.97-10.51,25.84-4.77-.73,23.18-25.73,5.01-33.77,6.57Z",
      1: "m1488.6,581.02l-6.5,61.35-191.75,52.05-85.39,23.18-176.7-65.84.07-4.32,82.45-18.24.81-25.82,121.75,38.87,61.57-14.76,193.69-46.46Z",
      0: "M1215.3,825.4l94.6-30.5l0.3-4.7l-53.2-21.5l0,0l218.7-66.5l6.3-59.9l0,0l-277.2,75.2l-176.7-65.8l-0.7,48l-103.9-42l-60,13.8L1215.3,825.4z",
    },
    f1008: {
      6: "m1080.21,391.43l-.37,48.65-36.95-.12h0l60.87,37.33h0l36.87-1.41.31-27.5,18.4-.85.83-31.23,150.1-6.27,45.21-1.89,1.35-21.22-69.5-22.71-177.64,6.22-.34,19.91-29.14,1.1Z",
      5: "m1483.02,451.28l-6.38,84.56-304.99,18.21h0l-84.55-56.79h0l53.16-2.68.68-46.19,18.4-.85.83-31.23,199.54-8.34,24.54,8.62-.7,10.32,26.68-1.19,72.78,25.57Z",
      4: "m1140.63,475.87l-.37,18.7-37.07,1.87-16.09.81-.41,31.31-.08,6.37-.07,5.9-.05,4.26-57.88,3.3-52.36-44.37-.03-3.86,66.44-3.32.24-56.89,60.87,37.33,36.87-1.41Z",
      3: "m1476.64,535.83l-6.71,76.09-300.94,21.1-89.14,6.25-72.19-68.36v-4.51s78.6-4.64,78.6-4.64l.84-64.5,84.55,56.79,304.99-18.21Z",
      2: "m1086.47,545.1l-.22,16.65-28.71,1.71-49.21,2.9-.68.04v4.51s10.88,10.15,10.88,10.15l26.99,25.76h0l-17.02,2.05-51.81-50.37-.03-3.78,65.76-3.79v-3.3s44.07-2.52,44.07-2.52Z",
      1: "m1469.93,611.92l-5.55,67.7-419.54,30.15h0l-66.79-77.44v-.31l87.97-5.75,13.83,13.01,18.74-1.31,70.4-4.94,300.94-21.1Z",
      0: "M871.4,626.4l58.2-4.5l48.7,66l-0.3-55.6l66.7,77.5l419.7-30.2l-5.9,66.9l0,0l-342.8,30.9l22.7,25.4l-0.1,5l-137.1,13L871.4,626.4z",
    },
    f1009: {
      6: "m1455.86,420.8h-2.84l-3.14,61.89h-15.86l-12.05-21.48-7.2-.06.06-10.86-5.78-10.28-226.87-2.58-3.93,31.31-23.99-.42.98-45.44,1.91-13.26,77.15.11-.81-18.46,193.15,2.14h.61s.04,0,.04,0l-.04-.06h7.43l21.17,25.83v1.61Z",
      5: "m1421.97,461.21l12.05,21.48,5.38,9.27v1.33h-4.25s-6.01,90.21-6.01,90.21l-342.69-6.66.68-90.32,7.03-19.26,84.08,1.48,3.93-31.31,226.87,2.58,5.78,10.28-.06,10.86,7.2.06Z",
      4: "",
      3: "m1086.46,576.84l342.69,6.66-5.43,80.38-337.93-8.81-92.63-2.41-.04-5.12,30.27-66.84,63.06-.09v-3.5",
      2: "",
      1: "m1423.73,663.88l-5.28,67.82-459.93-13.12h.13-.13l34.37-76.19,2.52.06-.68,1.52-1.6,3.56.04,5.12,11.94.31,80.69,2.1,337.93,8.81Z",
      0: "M958.5,718.6l459.9,13.1l-5.1,76.8l-386.4-12.8v4.5l-7.7,26.2l-158.6-4.8l-0.2-5l82.3-167l47.8,0.8L958.5,718.6l0.1-0.3L958.5,718.6",
    },
  },
};

export const StateContext = React.createContext();

const ProjectData = ({ children }) => {
  const [state, setState] = useState(initialState);

  const getData = () => {
    fetch(appSetup.dataPath, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then(function (response) {
        if (response.status !== 200) {
          setState((prevState) => ({
            ...prevState,
            stateIsLoading: "error",
          }));
          throw new Error("External data not found");
        } else {
          return response.json();
        }
      })
      .then(function (data) {
        if (Array.isArray(data)) {
          setState((prevState) => ({
            ...prevState,
            units: data,
            stateIsLoading: false,
          }));
        } else {
          setState((prevState) => ({
            ...prevState,
            stateIsLoading: "error",
          }));
          throw new Error("External data is not an array");
        }
      })
      .catch((error) => {
        console.warn(error.message);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <StateContext.Provider value={[state, setState]}>
      {children}
    </StateContext.Provider>
  );
};

export default ProjectData;
